import {
  GET_PROMOTION_INFO_SUCCESS,
  GET_PROMOTION_INFO_START,
  GET_PROMOTION_INFO_FAIL,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_START,
  GET_PARTNERS_FAIL,
  GET_PROMOTIONS_SUCCESS,
  GET_PROMOTIONS_FAIL,
  GET_PROMOTIONS_START,
  GET_PARTNER_INFO_START,
  GET_PARTNER_INFO_SUCCESS,
  GET_PARTNER_INFO_FAIL,
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_FAIL,
  POST_CREATE_PARTNER_START,
  POST_CREATE_PARTNER_SUCCESS,
  POST_CREATE_PARTNER_FAIL,
  DELETE_PARTNER_START,
  DELETE_PARTNER_SUCCESS,
  DELETE_PARTNER_FAIL,
  GET_PARTNERS_LIST_START,
  GET_PARTNERS_LIST_SUCCESS,
  GET_PARTNERS_LIST_FAIL,
  GET_CITIES_START,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAIL,
  UPDATE_PARTNER_START,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAIL,
  GET_CMS_START,
  GET_CMS_SUCCESS,
  GET_CMS_FAIL,
  CREATE_PROMOTION_START,
  UPDATE_PROMOTION_START,
  UPDATE_PROMOTION_FAIL,
  CREATE_PROMOTION_FAIL,
  CREATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION_SUCCESS,
  UPLOAD_PROMO_FILE_START,
  UPLOAD_CUSTOMER_FILE_START,
  UPLOAD_PROMO_FILE_SUCCESS,
  UPLOAD_CUSTOMER_FILE_SUCCESS,
  UPLOAD_PROMO_FILE_FAIL,
  UPLOAD_CUSTOMER_FILE_FAIL,
  GET_PROMO_FILES_START,
  GET_CUSTOMER_FILES_START,
  GET_CUSTOMER_FILE_START,
  GET_PROMO_FILES_SUCCESS,
  GET_CUSTOMER_FILES_SUCCESS,
  GET_CUSTOMER_FILE_SUCCESS,
  GET_PROMO_FILES_FAIL,
  GET_CUSTOMER_FILES_FAIL,
  GET_CUSTOMER_FILE_FAIL,
  DELETE_CUSTOMER_FILE_FAIL,
  DELETE_PROMO_FILE_FAIL,
  ARCHIVE_PARTNER_START,
  ARCHIVE_PROMOTION_START,
  ARCHIVE_PARTNER_SUCCESS,
  ARCHIVE_PROMOTION_SUCCESS,
  ARCHIVE_PARTNER_FAIL,
  ARCHIVE_PROMOTION_FAIL,
  GET_PROMO_CODES_START,
  GET_PROMO_CODES_SUCCESS,
  GET_PROMO_CODES_FAIL,
  UNARCHIVE_PARTNER_START,
  UNARCHIVE_PARTNER_SUCCESS, UNARCHIVE_PARTNER_FAIL,
  UPDATE_PARTNERS_POSITIONS_SUCCESS,
  UPDATE_PARTNERS_POSITIONS_START,
  UPDATE_PARTNERS_POSITIONS_FAIL,
  UPDATE_PROMOTIONS_POSITIONS_FAIL,
  UPDATE_PROMOTIONS_POSITIONS_SUCCESS,
  UPDATE_PROMOTIONS_POSITIONS_START
} from './constants';

export const partnersReducer = (
  state = {
    partners: {},
    partnersList: [],
    promotions: {},
    promotionCard: {},
    partnerCard: {},
    cities: [],
    fetching: false,
    fetchingPromotions: false,
    error: null,
    errorArchive: null,
    fetchingFile: false,
    uploadCustomerFiles: [],
    uploadPromoFiles: [],
    customerFiles: {},
    promoFiles: [],
    cms: [],
    promoCodes: {}
  },
  action
) => {
  switch (action.type) {
    case GET_PARTNERS_START:
    case GET_PARTNER_INFO_START:
    case GET_SUBSCRIBERS_LIST_START:
    case DELETE_PARTNER_START:
    case GET_PARTNERS_LIST_START:
    case ARCHIVE_PARTNER_START:
    case UNARCHIVE_PARTNER_START:
        return { ...state, fetching: true, error: null }
    case GET_PROMOTIONS_START:
    case GET_PROMOTION_INFO_START:
    case GET_PROMO_FILES_START:
    case GET_CUSTOMER_FILES_START:
    case GET_CUSTOMER_FILE_START:
    case ARCHIVE_PROMOTION_START:
    case GET_PROMO_CODES_START:
      return { ...state, fetchingPromotions: true, error: null }
    case UPLOAD_PROMO_FILE_START:
    case UPLOAD_CUSTOMER_FILE_START:
      return { ...state, fetchingFile: true, error: null }
    case GET_CITIES_START:
    case POST_CREATE_PARTNER_START:
    case UPDATE_PARTNER_START:
    case GET_CMS_START:
    case CREATE_PROMOTION_START:
    case UPDATE_PROMOTION_START:
    case UPDATE_PARTNERS_POSITIONS_START:
    case UPDATE_PROMOTIONS_POSITIONS_START:
    case CREATE_PROMOTION_SUCCESS:
    case UPDATE_PROMOTION_SUCCESS: // TODO
      return { ...state, error: null }

    case ARCHIVE_PARTNER_SUCCESS: // TODO
      return {
        ...state,
        error: null,
        fetching: false,
        partnerCard: +action.payload === state.partnerCard.id ? { ...state.partnerCard, status: 'Архив', updated_at: new Date() } : state.partnerCard
      }

    case UNARCHIVE_PARTNER_SUCCESS: // TODO
      return {
        ...state,
        error: null,
        fetching: false,
        partnerCard: +action.payload === state.partnerCard.id ? { ...state.partnerCard, status: 'Действующий', updated_at: new Date() } : state.partnerCard
      }

    case ARCHIVE_PROMOTION_SUCCESS: // TODO
      return {
        ...state,
        error: null,
        fetchingPromotions: false,
        promotionCard: +action.payload === state.promotionCard.id ? { ...state.promotionCard, status: 'Архив' } : state.promotionCard,
        promotions: (() => {
          const promotions = state.promotions;
          const id = promotions.items.findIndex(item => item.id === +action.payload);
          promotions.items[id].status = 'Архив';
          return promotions;
        })()
      }

    case GET_PROMO_CODES_SUCCESS:
      return { ...state, promoCodes: { ...action.payload }, fetchingPromotions: false };

    case GET_PARTNERS_SUCCESS:
      return { ...state, partners: { ...action.payload }, fetching: false };

    case GET_PROMOTIONS_SUCCESS:
      return { ...state, promotions: { ...action.payload }, fetchingPromotions: false };

    case GET_PROMOTION_INFO_SUCCESS:
      return { ...state, promotionCard: { ...action.payload }, fetchingPromotions: false };

    case GET_PARTNER_INFO_SUCCESS:
    case UPDATE_PARTNER_SUCCESS: // TODO
      return { ...state, partnerCard: { ...action.payload }, fetching: false };

    case GET_PARTNERS_LIST_SUCCESS:
      return { ...state, partnersList: action.payload, fetching: false };

    case GET_CITIES_SUCCESS:
      return { ...state, cities: action.payload, fetching: false }

    case GET_CMS_SUCCESS:
      return { ...state, cms: action.payload, fetching: false }

    case POST_CREATE_PARTNER_SUCCESS: // TODO
      return {
        ...state,
        fetching: false,
        partnersList: [
          { ...action.payload?.data?.instance, label: action.payload?.data?.instance.name },
          ...state.partnersList,
        ],
      };

    case DELETE_PARTNER_SUCCESS:
      return {
        ...state,
        fetching: false,
        partnersList: state.partnersList.filter((partner) => partner.id !== action.payload)
      };

    case UPLOAD_PROMO_FILE_SUCCESS:
      return { ...state, fetchingFile: false, uploadPromoFiles: [...state.uploadPromoFiles, action.payload] }
    case UPLOAD_CUSTOMER_FILE_SUCCESS:
      return { ...state, fetchingFile: false, uploadCustomerFiles: [...state.uploadCustomerFiles, action.payload] }

    case GET_PROMO_FILES_SUCCESS:
      return { ...state, fetchingPromotions: false, promoFiles: action.payload }
    case GET_CUSTOMER_FILES_SUCCESS:
      return { ...state, fetchingPromotions: false, customerFiles: action.payload }
    case GET_CUSTOMER_FILE_SUCCESS:
      return { ...state, fetchingPromotions: false, customerFiles: action.payload }
    case UPDATE_PARTNERS_POSITIONS_SUCCESS:
      return { ...state, fetching: false, partners: { ...state.partners, items: action.payload } }
    case UPDATE_PROMOTIONS_POSITIONS_SUCCESS:
      return { ...state, fetching: false, promotions: { ...state.promotions, items: action.payload } }

    case GET_PARTNERS_FAIL:
    case GET_PROMOTION_INFO_FAIL:
    case GET_PROMOTIONS_FAIL:
    case GET_PARTNER_INFO_FAIL:
    case GET_SUBSCRIBERS_LIST_FAIL:
    case POST_CREATE_PARTNER_FAIL:
    case DELETE_PARTNER_FAIL:
    case GET_PARTNERS_LIST_FAIL:
    case GET_CITIES_FAIL:
    case UPDATE_PARTNER_FAIL:
    case GET_CMS_FAIL:
    case UPDATE_PROMOTION_FAIL:
    case CREATE_PROMOTION_FAIL:
    case UPLOAD_PROMO_FILE_FAIL:
    case UPLOAD_CUSTOMER_FILE_FAIL:
    case GET_CUSTOMER_FILES_FAIL:
    case GET_CUSTOMER_FILE_FAIL:
    case DELETE_CUSTOMER_FILE_FAIL:
    case DELETE_PROMO_FILE_FAIL:
    case GET_PROMO_CODES_FAIL:
    case UPDATE_PARTNERS_POSITIONS_FAIL:
    case UPDATE_PROMOTIONS_POSITIONS_FAIL:
    case UNARCHIVE_PARTNER_FAIL:
      return { ...state, error: action.payload, fetching: false, fetchingPromotions: false, fetchingFile: false }
    case ARCHIVE_PARTNER_FAIL:
    case ARCHIVE_PROMOTION_FAIL:
      return { ...state, error: null, errorArchive: action.payload, fetching: false, fetchingPromotions: false, fetchingFile: false }
    case GET_PROMO_FILES_FAIL:
      return { ...state, error: null, fetching: false, fetchingPromotions: false, fetchingFile: false }

    default:
      return state
  }
};
